import { useEffect, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import { coreApi, studioApi } from '@/api';
import { authApiWithToken } from '@/apis/auth';
import { getAccessToken } from '@/auth';
import {
  isRealworldAdminRole,
  isSchoolAdminAccessiblePlan,
  isSchoolAdminRole
} from '@/utils/roleAccess';

export default function LoginCallback() {
  const history = useHistory();

  const { code, redirect } = useMemo(() => {
    const searchParams = new URLSearchParams(history.location.search);

    return { code: searchParams.get('code'), redirect: searchParams.get('redirect') };
  }, [history.location.search]);

  useEffect(() => {
    (async () => {
      const { data: tokens } = await studioApi.get<LoginResponseModel>('/auth/loginCallback', {
        params: { code }
      });

      localStorage.setItem('refreshToken', tokens.refreshToken);
      localStorage.setItem('accessToken', tokens.accessToken);

      getAccessToken.clear();
      await Promise.all([
        (async () => {
          await authApiWithToken.apiAuthLoginPost();
        })(),
        (async () => {
          const [appsResponse, meResponse] = await Promise.all([
            coreApi.get<CommonResponseModel<ApplicationResponseModel[]>>('/apps', {
              headers: { 'x-rwd-api-version': '1.1' }
            }),
            coreApi.get<MyInfo>('/api/me')
          ]);

          const apps = appsResponse?.data?.data;
          const me = meResponse?.data;

          const isAdmin = isRealworldAdminRole(me?.role);
          const isSchoolAdmin = isSchoolAdminRole(me?.role);

          if (!isAdmin && apps && apps.length > 0) {
            const defaultAppId = isSchoolAdmin
              ? apps.find((app) => isSchoolAdminAccessiblePlan(app.planType))?.id ?? apps[0]?.id
              : apps[0]?.id;

            if (defaultAppId) {
              localStorage.setItem('defaultChannelID', defaultAppId);
            }
          }
        })()
      ]);

      window.location.href = redirect ?? '/apps';
    })();
  }, []);

  return null;
}
